import { z } from 'zod';

import { codeInputSchema } from '@/shared/utils/validation';

export const enableMfaInputSchema = z.object({
  code: codeInputSchema(),
});
